export const RESPONSE_CODES = [
  {
    label: 'OK',
    value: 200,
  },
  {
    label: 'Accepted',
    value: 202,
  },
  {
    label: 'Bad Request',
    value: 400,
  },
  {
    label: 'Unauthorized',
    value: 401,
  },
  {
    label: 'Forbidden',
    value: 403,
  },
  {
    label: 'Not Found',
    value: 404,
  },
  {
    label: 'Our Fault',
    value: 424,
  },
  {
    label: 'Internal Server Error',
    value: 500,
  },
  {
    label: 'Bad Gateway',
    value: 502,
  },
  {
    label: 'Gateway Timeout',
    value: 504,
  },
];
